import * as Yup from 'yup'

import { getActivePlacementsInitialValues } from '../../../placements/helpers'

import {
  AUDIENCES_OPTION,
  CUSTOM_AUDIENCES,
  CUSTOM_AUDIENCES_EXCLUSION
} from '../../../../ReusableFormFields/Audiences/AudiencesFields/fields'
import { OPTION_YES } from '../../../../../constants/forms'
import {
  PROMOTED_PIXEL,
  getPromotedObjectInitialValues
} from '../../../../../constants/selectLists/customEventTypes/fields'
import {
  END_DATE,
  endDateValidation,
  START_DATE,
  startDateValidation,
  startEndDateRangeInitialValues
} from '../../../../ReusableFormFields/StartEndDateRangeFields/fields'
import { LINE_ITEM } from '../../../../Multiplatform/UploadAdCreative/UploadAdCreativeLineItemForm/fields'
import { getBudgetValidation } from '../../../../Multiplatform/UploadAdCreative/UploadAdCreativeCampaignForm/fields'
import { BUDGET_LIFETIME } from '../../../../Google/UploadGoogleAdCreative/UploadGoogleAdCreativeForm/CampaignForm/fields'
import { IMPRESSIONS } from '../../../../Multiplatform/UploadAdCreative/fields'
import { getImpressionsValidation } from '../../../../Multiplatform/UploadAdCreative/ImpressionsBudgetSection/validation'
import {
  EXCLUDE_LOCATIONS_CHECKBOX,
  GEO_EXCLUSIONS,
  SHOW_COUNTRIES,
  SHOW_COUNTRY_CHOICE,
  SHOW_OPTION,
  SHOW_OPTION_COUNTRIES,
  SHOW_OPTION_REGIONS,
  SHOW_REGIONS
} from '../../../../ReusableFormFields/GeolocationsFields/fields'
import { regionsArraySchema } from '../../../../../features/validations/gelolocations'
import { AGE_MAX, AGE_MIN, FEMALE, MALE } from '../../../fields'
import { INTERESTS } from '../../../../ReusableFormFields/InterestsFields/fields'
import { PLACEMENT_POSITIONS, TARGET_COST_CAP } from '../../../../Multiplatform/LineItemForms/fields'
import {
  APP_INSTALLS,
  OUTCOME_APP_PROMOTION,
  OUTCOME_ENGAGEMENT,
  OUTCOME_LEADS,
  OUTCOME_TRAFFIC
} from '../../../../../constants/campaigns'
import {
  ENGAGEMENT_TYPE,
  POST_ENGAGEMENT
} from '../../../LineItemForms/LineItemFacebookCreate/LineItemFacebookCreateForm/fields'
import { BEHAVIORS } from '../../../../ReusableFormFields/Audiences/FacebookAudienceFields/FacebookUploadCreativeAudienceFields/AdvancedAudienceTargetingSection/BehavioursSelect/fields'
import { FB_PAGE_CHOICE } from '../../../AdForms/fields'
import {
  LIST_ITEM_OPTION,
  OPTION_EXISTING_LIST_ITEM,
  OPTION_NEW_LIST_ITEM
} from '../../../../../hooks/formHooks/listItemFormHooks/fields'
import { APPLICATION_ID } from '../reusableFields/AppListField/fields'
import { mobilePlatformsEnums } from '../reusableFields/fields'

export const PLACEMENTS_OPTION = 'placements_option'
export const ALL_PLACEMENTS = 'all_placements'
export const RECOMMENDED_PLACEMENTS = 'recommended_placements'
export const FACEBOOK_AND_INSTAGRAM = 'facebook_and_instagram'
export const FACEBOOK_ONLY = 'facebook_only'
export const INSTAGRAM_ONLY = 'instagram_only'
export const FACEBOOK_AND_INSTAGRAM_FEEDS = 'facebook_and_instagram_feeds'
export const FACEBOOK_FEEDS = 'facebook_feeds'
export const INSTAGRAM_FEEDS = 'instagram_feeds'
export const STORIES_AND_REELS = 'stories_and_reels'
export const LINE_ITEM_OBJECTIVE = 'objective'

export const ANDROID_APP_PROMOTION = 'android_app_promotion'
export const IOS_APP_PROMOTION = 'ios_app_promotion'
export const CUSTOM = 'custom'

export const ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS = 'are_we_able_to_track_landing_page_views'
export const NO_I_HAVE_NOT_LINKED_BY_WEBSITE_PIXEL = 'no_i_have_not_linked_by_website_pixel'
export const YES_I_HAVE_LINKED_BY_WEBSITE_PIXEL = 'yes_i_have_linked_by_website_pixel'

export const USER_OS = 'user_os'
export const OBJECT_STORE_URL = 'object_store_url'
// custom_conversion_id
export const CUSTOM_CONVERSION_ID = 'custom_conversion_id'
export const CONVERSION_EVENT_TYPE_RADIO_BUTTON = 'conversionEventTypeRadioButton'
export const STANDARD_DATASET_EVENT = 'standardDatasetEvent'
export const CUSTOM_CONVERSION_EVENT = 'customConversionEvent'
export const LEADS_ON_META_LEAD_ADS_FORM = 'leadsOnMetaLeadAdsForm'

export const mobilePlatforms = [
  { value: mobilePlatformsEnums.iOS, label: 'iOS' },
  { value: mobilePlatformsEnums.Android, label: 'Android' }
]

const initialAppPromotionValues = {
  [APPLICATION_ID]: '',
  [USER_OS]: mobilePlatforms[0].value,
  // [OBJECT_STORE_URL]: 'https://',
  [LINE_ITEM_OBJECTIVE]: APP_INSTALLS
}

const getInitialPromotedObjectValues = (preselectedValues, campaignObjective) => {
  return {
    // initial
    ...getPromotedObjectInitialValues(campaignObjective),
    [ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS]: NO_I_HAVE_NOT_LINKED_BY_WEBSITE_PIXEL,
    // preselected
    ...(preselectedValues[PROMOTED_PIXEL] && { [PROMOTED_PIXEL]: preselectedValues[PROMOTED_PIXEL] }),
    ...(preselectedValues[ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS] && {
      [ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS]: preselectedValues[ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS]
    })
  }
}

export const getInitialValues = ({ isLineItemsExist, campaignObjective, preselectedValues }) => {
  const initialActivePlacementsValues = getActivePlacementsInitialValues(campaignObjective)

  return {
    // line_item
    [LIST_ITEM_OPTION]: isLineItemsExist ? OPTION_EXISTING_LIST_ITEM : OPTION_NEW_LIST_ITEM,
    [LINE_ITEM]: '',
    // budget
    [BUDGET_LIFETIME]: '',
    [IMPRESSIONS]: '',
    // dates
    ...startEndDateRangeInitialValues,
    [AUDIENCES_OPTION]: OPTION_YES,
    [CUSTOM_AUDIENCES]: [],
    [CUSTOM_AUDIENCES_EXCLUSION]: [],
    // geotargetting
    [SHOW_OPTION]: SHOW_OPTION_COUNTRIES,
    [SHOW_COUNTRIES]: [],
    [SHOW_COUNTRY_CHOICE]: '',
    [SHOW_REGIONS]: [],
    [EXCLUDE_LOCATIONS_CHECKBOX]: false,
    [GEO_EXCLUSIONS]: [],
    // gender
    [MALE]: true,
    [FEMALE]: true,
    // age
    [AGE_MIN]: 18,
    [AGE_MAX]: 65,
    // interests
    [INTERESTS]: [],
    // behaviours
    [BEHAVIORS]: [],
    // placements
    [PLACEMENTS_OPTION]: RECOMMENDED_PLACEMENTS,
    [PLACEMENT_POSITIONS]: initialActivePlacementsValues,

    // promoted object
    ...getInitialPromotedObjectValues(preselectedValues, campaignObjective),

    [TARGET_COST_CAP]: '',
    ...(campaignObjective === OUTCOME_APP_PROMOTION && initialAppPromotionValues),
    [ENGAGEMENT_TYPE]: POST_ENGAGEMENT,
    ...(campaignObjective === OUTCOME_ENGAGEMENT && {
      [FB_PAGE_CHOICE]: ''
    }),
    [CONVERSION_EVENT_TYPE_RADIO_BUTTON]: STANDARD_DATASET_EVENT,
    [CUSTOM_CONVERSION_ID]: '',
    [FB_PAGE_CHOICE]: ''
  }
}

const appPromotionValidationSchema = {
  [APPLICATION_ID]: Yup.string().when(LIST_ITEM_OPTION, {
    is: OPTION_NEW_LIST_ITEM,
    then: () => Yup.string().required('Please select app')
  })
}

const getEventSourceValidation = campaign => {
  if (campaign.objective === OUTCOME_TRAFFIC) {
    return {
      [PROMOTED_PIXEL]: Yup.string().when(ARE_WE_ABLE_TO_TRACK_LANDING_PAGE_VIEWS, {
        is: YES_I_HAVE_LINKED_BY_WEBSITE_PIXEL,
        then: () => Yup.string().required('Please select event source')
      })
    }
  } else if (campaign.objective === OUTCOME_LEADS) {
    return {
      [PROMOTED_PIXEL]: Yup.string().when([CONVERSION_EVENT_TYPE_RADIO_BUTTON, LIST_ITEM_OPTION], {
        is: (typeOfLead, lineItemOption) => {
          return typeOfLead === STANDARD_DATASET_EVENT && lineItemOption === OPTION_NEW_LIST_ITEM
        },
        then: () => Yup.string().required('Please select event source')
      }),
      [FB_PAGE_CHOICE]: Yup.string().when([CONVERSION_EVENT_TYPE_RADIO_BUTTON, LIST_ITEM_OPTION], {
        is: (typeOfLead, lineItemOption) => {
          return typeOfLead === LEADS_ON_META_LEAD_ADS_FORM && lineItemOption === OPTION_NEW_LIST_ITEM
        },
        then: () => Yup.string().required('Please select Facebook page')
      })
    }
  } else {
    return {}
  }
}

export const getValidationSchema = ({
  campaign,
  showImpressions,
  remainingBudget,
  remainingImpressions,
  currencySymbol,
  showTargetCostCapField,
  showPromotedObjectStepForAppPromotionCampaign
}) => {
  const isCampaignBudgetEmpty = !campaign['budget_lifetime']

  return Yup.object({
    // line item
    [LINE_ITEM]: Yup.string().when(LIST_ITEM_OPTION, {
      is: OPTION_EXISTING_LIST_ITEM,
      then: () => Yup.string().required('Please select line item')
    }),

    // budget
    ...(isCampaignBudgetEmpty &&
      !showImpressions && {
        [BUDGET_LIFETIME]: Yup.number().when(LIST_ITEM_OPTION, {
          is: OPTION_NEW_LIST_ITEM,
          then: () => getBudgetValidation({ remainingBudget, currencySymbol })
        })
      }),
    ...(isCampaignBudgetEmpty &&
      showImpressions && {
        [IMPRESSIONS]: Yup.number().when(LIST_ITEM_OPTION, {
          is: OPTION_NEW_LIST_ITEM,
          then: () =>
            getImpressionsValidation({
              remainingImpressions,
              requiredMessage: 'Please enter an impressions budget'
            })
        })
      }),

    // dates
    [START_DATE]: Yup.string().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () => startDateValidation
    }),
    [END_DATE]: Yup.string().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () => endDateValidation
    }),
    // custom audiences,
    [CUSTOM_AUDIENCES]: Yup.array().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () =>
        Yup.array().when(AUDIENCES_OPTION, {
          is: OPTION_YES,
          then: () => Yup.array().min(1, 'Please select at least one option')
        })
    }),

    [SHOW_COUNTRIES]: Yup.array().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () =>
        Yup.array().when(SHOW_OPTION, {
          is: SHOW_OPTION_COUNTRIES,
          then: () => Yup.array().min(1, 'Please select at least one option')
        })
    }),
    [SHOW_REGIONS]: Yup.array().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () =>
        Yup.array().when(SHOW_OPTION, {
          is: SHOW_OPTION_REGIONS,
          then: () => regionsArraySchema
        })
    }),
    [GEO_EXCLUSIONS]: Yup.array().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () =>
        Yup.array().when(EXCLUDE_LOCATIONS_CHECKBOX, {
          is: true,
          then: () => regionsArraySchema
        })
    }),
    ...(showTargetCostCapField && {
      [TARGET_COST_CAP]: Yup.number().when(LIST_ITEM_OPTION, {
        is: OPTION_NEW_LIST_ITEM,
        then: () => Yup.number().required('Please enter target cost cap')
      })
    }),
    ...getEventSourceValidation(campaign),
    [CUSTOM_CONVERSION_ID]: Yup.string().when(CONVERSION_EVENT_TYPE_RADIO_BUTTON, {
      is: CUSTOM_CONVERSION_EVENT,
      then: () => Yup.string().required('Please enter custom conversion event')
    }),
    ...(showPromotedObjectStepForAppPromotionCampaign && appPromotionValidationSchema)
  })
}
